import Module from '../../Module';

class GalleryService extends Module {
  get baseURL() {
    return '/api/v1/products'
  }

  parseGallery(gallery) {
    if(!gallery) return []

    return gallery.map(g => {
      return this.parseGalleryItem(g)
    })
  }

  parseGalleryItem(item) {
    return {
      createdAt: item.createdAt,
      deletedAt: item.deletedAt,
      id: item.id,
      image: item.image ? this.parseImage(item.image) : null,
      imageId: item.imageId,
      ownerId: item.ownerId,
      ownerType: item.ownerType,
      updatedAt: item.updatedAt,
    }
  }

  parseImage(image) {
    return {
      createdAt: image.createdAt,
      deletedAt: image.deletedAt,
      description: image.description,
      id: image.id,
      title: image.title,
      updatedAt: image.updatedAt,
      url: image.url,
    }
  }
}

export default new GalleryService()
